import clsx from "clsx";
import { ArrowsRightIcon } from "@/shared/icons";
import InventoryCloseButton from "@/domains/inventory/components/InventoryCloseButton";

type Props = {
  onClose: () => void;
};

export default function InventorySearchConfiscationHeader({ onClose }: Props) {
  return (
    <div
      className={clsx(
        "px-7.5 h-[3.75rem] w-full",
        "flex items-center justify-between gap-1.5 bg-gradient-to-br from-[#2158E7]/30 via-transparent to-dark-900",
      )}
    >
      <div className="flex items-center gap-2.5">
        <ArrowsRightIcon size={24} className="text-[#618DFF]" />
        <div className="text-18 font-medium">Конфискация</div>
      </div>

      <InventoryCloseButton onClick={onClose} />
    </div>
  );
}
